import { PayloadAction } from '@reduxjs/toolkit';

import { validateDate } from '@/features/histogram-form/model/services/validate-date.service';
import { createSlice } from '@/shared/lib/helpers/create-store-logic';

import { validateName } from '../services/validate-name.service';
import { CreateHistogramFormSchema } from '../types/create-histogram-form.interface';

export const initialState: CreateHistogramFormSchema = {
	name: '',
	validationError: {},
};

export const createHistogramFormSlice = createSlice({
	name: 'create-histogram-form',
	initialState,
	reducers: {
		setName: (state, action: PayloadAction<string>) => {
			state.validationError.name = validateName(action.payload);

			state.name = action.payload;
		},
		setEndDate: (state, action: PayloadAction<{ date?: Date; timezone: string }>) => {
			state.validationError.endDate = validateDate(action.payload.date, action.payload.timezone);
			state.endDate = action.payload.date;
		},
		setStartDate: (state, action: PayloadAction<{ date?: Date; timezone: string }>) => {
			state.validationError.startDate = validateDate(action.payload.date, action.payload.timezone);

			state.startDate = action.payload.date;
		},
		setHistogram: (state, action: PayloadAction<string>) => {
			state.selectedHistogram = action.payload;
		},
		resetHistogram: (state) => {
			state.selectedHistogram = undefined;
		},
		setValidationError: (state) => {
			state.validationError.name = validateName(state.name);
			state.validationError.startDate = validateDate(state.startDate);
			state.validationError.endDate = validateDate(state.endDate);
		},
		resetForm: (state) => {
			state.name = '';
			state.endDate = undefined;
			state.startDate = undefined;
			state.validationError = {};
		},
	},
});

export const {
	actions: createHistogramFormActions,
	reducer: createHistogramFormReducer,
	useActions: useCreateHistogramFormActions,
} = createHistogramFormSlice;
